var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    style: {
      color: "#87aaca"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.249 1.646a1.5 1.5 0 0 1 .497 2.958A7.502 7.502 0 0 0 12 19.5v3C6.201 22.5 1.5 17.8 1.5 12c0-5.145 3.726-9.51 8.749-10.354Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#loading_svg__a)",
    d: "M16.892 4.298a1.5 1.5 0 0 1 2.119-.115A10.476 10.476 0 0 1 22.5 12c0 5.8-4.701 10.5-10.5 10.5v-3a7.5 7.5 0 0 0 5.007-13.084 1.5 1.5 0 0 1-.115-2.118Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "loading_svg__a",
    x1: 17,
    x2: 17,
    y1: 4.5,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87AACA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87AACA"
  })))));
};
export default SvgLoading;